export var defaultMonthOptions = {
    width: 7,
    height: 6,
    firstDayOfWeek: 1
};
export var defaultFormatOptions = {
    locale: 'en',
    monthTitle: 'MMMM',
    yearTitle: 'YYYY',
    dayLabel: 'D',
    weekNumbers: 'w'
};
export var defaultRenderOptions = {
    displayMonths: 1,
    showWeekNumbers: true
};
//# sourceMappingURL=_defaults.js.map


//////////////////
// WEBPACK FOOTER
// /revet-web/node_modules/ngx-bootstrap/datepicker/reducer/_defaults.js
// module id = ../../../../ngx-bootstrap/datepicker/reducer/_defaults.js
// module chunks = vendor